function getCurrencySymbols(symbol) {
    try {
        const currencySymbols = {
            AED: "د.إ",
            AFN: "Af",
            ALL: "Lek",
            AMD: "",
            ANG: "ƒ",
            AOA: "Kz",
            ARS: "$",
            AUD: "$",
            AWG: "ƒ",
            AZN: "мaн",
            BAM: "KM",
            BBD: "$",
            BDT: "৳",
            BGN: "лв",
            BHD: ".د.ب",
            BIF: "FBu",
            BMD: "$",
            BND: "$",
            BOB: "$b",
            BRL: "R$",
            BSD: "$",
            BTN: "Nu.",
            BWP: "P",
            BYR: "p.",
            BZD: "BZ$",
            CAD: "$",
            CDF: "FC",
            CHF: "CHF",
            CLF: "",
            CLP: "$",
            CNY: "¥",
            COP: "$",
            CRC: "₡",
            CUP: "⃌",
            CVE: "$",
            CZK: "Kč",
            DJF: "Fdj",
            DKK: "kr",
            DOP: "RD$",
            DZD: "دج",
            EGP: "£",
            ETB: "Br",
            EUR: "€",
            FJD: "$",
            FKP: "£",
            GBP: "£",
            GEL: "ლ",
            GHS: "¢",
            GIP: "£",
            GMD: "D",
            GNF: "FG",
            GTQ: "Q",
            GYD: "$",
            HKD: "$",
            HNL: "L",
            HRK: "kn",
            HTG: "G",
            HUF: "Ft",
            IDR: "Rp",
            ILS: "₪",
            INR: "₹",
            IQD: "ع.د",
            IRR: "﷼",
            ISK: "kr",
            JEP: "£",
            JMD: "J$",
            JOD: "JD",
            JPY: "¥",
            KES: "KSh",
            KGS: "лв",
            KHR: "៛",
            KMF: "CF",
            KPW: "₩",
            KRW: "₩",
            KWD: "د.ك",
            KYD: "$",
            KZT: "лв",
            LAK: "₭",
            LBP: "£",
            LKR: "₨",
            LRD: "$",
            LSL: "L",
            LTL: "Lt",
            LVL: "Ls",
            LYD: "ل.د",
            MAD: "د.م.",
            MDL: "L",
            MGA: "Ar",
            MKD: "дeн",
            MMK: "K",
            MNT: "₮",
            MOP: "MOP$",
            MRO: "UM",
            MUR: "₨",
            MVR: ".ރ",
            MWK: "MK",
            MXN: "$",
            MYR: "RM",
            MZN: "MT",
            NAD: "$",
            NGN: "₦",
            NIO: "C$",
            NOK: "kr",
            NPR: "₨",
            NZD: "$",
            OMR: "﷼",
            PAB: "B/.",
            PEN: "S/.",
            PGK: "K",
            PHP: "₱",
            PKR: "₨",
            PLN: "zł",
            PYG: "Gs",
            QAR: "﷼",
            RON: "lei",
            RSD: "Дин.",
            RUB: "py6",
            RWF: "ر.س",
            SAR: "﷼",
            SBD: "$",
            SCR: "₨",
            SDG: "£",
            SEK: "kr",
            SGD: "$",
            SHP: "£",
            SLL: "Le",
            SOS: "S",
            SRD: "$",
            STD: "Db",
            SVC: "$",
            SYP: "£",
            SZL: "L",
            THB: "฿",
            TJS: "TJS",
            TMT: "m",
            TND: "د.ت",
            TOP: "T$",
            TRY: "₤",
            TTD: "$",
            TWD: "NT$",
            TZS: "",
            UAH: "₴",
            UGX: "USh",
            USD: "$",
            UYU: "$U",
            UZS: "лв",
            VEF: "Bs",
            VND: "₫",
            VUV: "VT",
            WST: "WS$",
            XAF: "FCFA",
            XCD: "$",
            XDR: "",
            XOF: "",
            XPF: "F",
            YER: "﷼",
            ZAR: "R",
            ZMK: "ZK",
            ZWL: "Z$"
        };

        return currencySymbols[symbol] || "amount";
    } catch (err) {
        console.error("Error retrieving currency symbol:", err);
        return "amount";
    }
}

const rupees = getCurrencySymbols(Shopify.currency.active);
console.log(rupees);





 function setCookie(name, value, days) {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  return parts.length === 2 ? parts.pop().split(";").shift() : null;
}

function generateUniqueId() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
jQuery(document).ready(function () {
  const apiUrl = "https://middleware.technoboost.in/api/v1/";
  let currentProId, collectionData, productItemData;
  let customerId = "";
  if (typeof __st.cid != "undefined") {
    customerId = __st.cid;
  }

 

  async function createCollection(data) {
    try {

      const response = await $.ajax({
        url: `${apiUrl}wishlist/collection`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify(data),
      });
      return response.success ? response : response.status;
    } catch {
      return null;
    }
  }

  async function addProductToCollection(data) {
    try {
      const response = await $.ajax({
        url: `${apiUrl}wishlist/collection-item`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify(data),
      });

      return [response.success, data.groupId];
    } catch {
      return [false, null];
    }
  }

  function toggleButtonState(inputSelector, buttonSelector) {
    const textValue = $(inputSelector).val().trim();
    $(buttonSelector).attr("disabled", !textValue);
  }

  function check_wishlist_added(variantId) {

    jQuery(`.wishlist_img_main[data-prod-variant-id="${variantId}"]`).addClass(
      "active"
    );
  }

  function uncheck_wishlist_added(variantId) {
    jQuery(`.wishlist_img_main[data-prod-variant-id="${variantId}"]`).removeClass(
      "active"
    );
    jQuery(`.wishlist_img_main[data-prod-variant-id="${variantId}"]`)
      .closest(".ct_hart_icon_main")
      .find(".rb_wish_remove")
      .show();
    setTimeout(() => {
      jQuery(`.wishlist_img_main[data-prod-variant-id="${variantId}"]`)
        .closest(".ct_hart_icon_main")
        .find(".rb_wish_remove")
        .hide();
    }, 2000);
  }

  var uniqueId = getCookie("browserUniqueId") || generateUniqueId();
  if (__st.pageurl.indexOf("search") == -1) {
    wishlist_product_list();
  }
  else {
    setTimeout(() => {
      wishlist_product_list();
    }, 2000);
  }

  function wishlist_product_list() {
    $.ajax({
      url: `${apiUrl}customer/wishlist-productId?registrationId=${uniqueId}&customerId=${customerId}`,
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }).done(async function (response) {
      if (response.length > 0) {
        jQuery.each(response, function (index, element) {

          check_wishlist_added(element);
        });
        var product_count = response.length;
        $(".wishlist_product_tab_count").text(`(${product_count})`);
        $(".rb_wishlist_count").addClass("rb_active_wish");
      }
      else {
        jQuery(`.wishlist_img_main`).removeClass(
          "active"
        );
        $(".rb_wishlist_count").removeClass("rb_active_wish");

        //jQuery(`.rb_wishlist_count`).text(0);
      }
    });
  }
  // Wishlist Product

  // Event handlers
  $(document).on("click", ".wishlist_blank_icon", function () {
    var productType = "";
    const $parent = $(this).parent();
    currentProId = $parent.attr("data-prod-title");
    productType = $parent.attr("data-prod-metafiled-type");
    if (productType == "") {
      productType = $parent.attr("data-prod-type");
    }

    collectionData = {
      name: productType,
      customerEmail: "",
      accessToken: "",
      customerId: customerId,
      registrationId: "",
      device: "WEB",
      version: "2.4",
    };

    productItemData = {
      groupId: $parent.attr("data-prod-id"),
      name: currentProId,
      price: $parent.attr("data-prod-price"),
      sellingPrice: $parent.attr("data-prod-selling-price"),
      image: $parent.attr("data-prod-featured-image"),
      variantId: $parent.attr("data-prod-variant-id"),
      customerEmail: "",
      accessToken: "",
      customerId: customerId,
      registrationId: "",
      device: "WEB",
      version: "2.4",
      collectionName: "",
    };

    var uniqueId = getCookie("browserUniqueId") || generateUniqueId();
    setCookie("browserUniqueId", uniqueId, 365);

    $.ajax({
      url: `${apiUrl}wishlist/collection?registrationId=${uniqueId}&customerId=${customerId}`,
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }).done(async function (response) {

      if (response != "") {
        var result = response.filter(function (obj) {
          return obj.name === productType;
        });

        if (result.length > 0) {
          //$(".wishlist_popup_main").addClass("active");
          productItemData.collectionName = result[0].name;
          productItemData.registrationId = uniqueId;
          const added = await addProductToCollection(productItemData);
     
          if (added[0]) {
            $(".wishlist_popup_main").removeClass("active");
            $(".create_collection_input").val("");
            $(`.wishlist_img_main[data-prod-id="${added[1]}"]`).addClass(
              "active"
            );
            jQuery(`.wishlist_img_main[data-prod-id="${added[1]}"]`)
              .closest(".ct_hart_icon_main")
              .find(".wish_added")
              .show();
            setTimeout(() => {
              jQuery(`.wishlist_img_main[data-prod-id="${added[1]}"]`)
                .closest(".ct_hart_icon_main")
                .find(".wish_added")
                .hide();
            }, 2000);
            var count = jQuery(".rb_wishlist_count").text();
            var total_count = parseInt(count) + 1;

            // jQuery(".rb_wishlist_count").text(total_count);
            jQuery(".rb_wishlist_count").addClass("rb_active_wish");

          }

        }
        else {
          
          const collections = response.map((element) => {
            if(element.items.length > 0)
            {

              const items = element.items.slice(0, 4).map(
                (item) => `<img src="${item}" loading="lazy">`
              );
              return `
                  <div class="wishlist_collec_box">
                    <div class="wishlist_collec_img">
                      <div class="wishlist_collec_img_box_wrap">${items.join("")}</div>
                      <input type="radio" name="collection_id"  data-collection-id="${element.id}" data-collection-name="${element.name}">
                      <div class="wishlist_checkbox"></div>
                    </div>
                    <div class="wishlist_collec_title">${element.name}</div>
                    <div class="wishlist_collec_subtitle">${element.totalItem} Items</div>
                  </div>`;
            }
          });

          $(".wishlist_collec_inner").html(collections.join(""));
          $(".rdx_create_collection_btn").hide();
          $(".create_collection_btn_secend").show();
          $(".wishlist_collec_list").show();
          $(".rdx_create_collection_btn").show();
          $(".create_collection_btn_secend").hide();
          $(".wishlist_collec_list").show();
          jQuery(".wishlist_popup_main").addClass("active");

        }
      } else {
        $(".rdx_create_collection_btn").show();
        $(".create_collection_btn_secend").hide();
        $(".wishlist_collec_list").show();
        jQuery(".wishlist_popup_main").addClass("active");
      }
    });
  });
  jQuery(document).on("click", ".rb_revert_create_wishlist", function () {
    jQuery("input[name='collection_id']:checked").prop("checked", false);
    jQuery(".wishlist_popup_bottom_btn").removeClass("select_collection_checked");
    jQuery(".rdx_add_wish_btn").prop("disabled", true);
    jQuery(".current_input_row").removeClass("rb_wishlist_hidden");

  })
  jQuery(document).on("change", ".wishlist_collec_inner .wishlist_collec_box input[name='collection_id']", function () {
    var checked_count = jQuery("input[name='collection_id']:checked").length;
    if (checked_count > 0) {
      jQuery(".wishlist_popup_bottom_btn").addClass("select_collection_checked");
      jQuery(".rdx_add_wish_btn").prop("disabled", false);
      jQuery(".current_input_row").addClass("rb_wishlist_hidden");
    }
    else {
      jQuery(".current_input_row").removeClass("rb_wishlist_hidden");
    }
  })

  jQuery(document).on("click", ".rdx_add_wish_btn", async function () {

    if (!currentProId) return alert("No product ID selected.");
    var uniqueId = getCookie("browserUniqueId") || generateUniqueId();
    var Collection_name = jQuery("input[name='collection_id']:checked").attr("data-collection-name");
    productItemData.collectionName = Collection_name;
    productItemData.registrationId = uniqueId;
    const added = await addProductToCollection(productItemData);

    if (added[0]) {
      jQuery(".wishlist_popup_bottom_btn").removeClass("select_collection_checked");
      $(".wishlist_popup_main").removeClass("active");
      $(".create_collection_input").val("");
      $(`.wishlist_img_main[data-prod-id="${added[1]}"]`).addClass("active");
      jQuery(`.wishlist_img_main[data-prod-id="${added[1]}"]`)
        .closest(".ct_hart_icon_main")
        .find(".wish_added")
        .show();
      setTimeout(() => {
        jQuery(`.wishlist_img_main[data-prod-id="${added[1]}"]`)
          .closest(".ct_hart_icon_main")
          .find(".wish_added")
          .hide();
      }, 2000);
      var count = jQuery(".rb_wishlist_count").text();
      var total_count = parseInt(count) + 1;
      //jQuery(".rb_wishlist_count").text(total_count);
      jQuery(".rb_wishlist_count").addClass("rb_active_wish");


    } else {
      alert("Failed to add product to collection.");
    }

  })

  jQuery(document).on("click", ".ct_hart_icon_main .wishlist_fill_icon", function () {
    const $parent = $(this).parent();
    const groupId = $parent.attr("data-prod-variant-id");
    var uniqueId = getCookie("browserUniqueId") || generateUniqueId();

    $.ajax({
      url: `${apiUrl}customer/wishlist-productId?registrationId=${uniqueId}&customerId=${customerId}&groupId=${groupId}`,
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    }).done(async function (response) {
      if (response.success) {
        uncheck_wishlist_added(groupId);
        var count = jQuery(".rb_wishlist_count").text();
        var total_count = parseInt(count) - 1;
        //jQuery(".rb_wishlist_count").text(total_count);
       
      }
    });
  });
  jQuery(document).on("click", ".rb_collection_wishlist_icon_main .wishlist_fill_icon", function () {
    const $parent = $(this).parent();
    const groupId = $parent.attr("data-prod-variant-id");
    var $this = $(this);
    var uniqueId = getCookie("browserUniqueId") || generateUniqueId();
    $.ajax({
      url: `${apiUrl}customer/wishlist-productId?registrationId=${uniqueId}&customerId=${customerId}&groupId=${groupId}`,
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    }).done(async function (response) {
      if (response.success) {

        var data = await uncheck_wishlist_added(groupId);
        setTimeout(function () {

          $this.closest(".ct_collection_product_box_item").remove();
          if (jQuery(".rb_wishlist_all_product_list .ct_collection_product_box_item").length == 0) {
            jQuery(".rb_wishlist_collection_product_list").hide();
            getCollectionData(true);
            wishlist_product_list()


          }
          else {
            wishlist_product_list();
          }
        }, 500)


      }
    });
  });


  $(document).on("click", ".wishlist_popup_close, .wishlist_popup_bottom_btn .skip_btn", async function () {
  const $this = $(this);

  // Prevent multiple clicks by disabling the button temporarily
  if ($this.data('processing')) return;
  $this.data('processing', true);

  if (!currentProId) {
    $this.data('processing', false);
    return alert("No product ID selected.");
  }

  var uniqueId = getCookie("browserUniqueId") || generateUniqueId();
  collectionData.registrationId = uniqueId;

  try {
    const collectionResponse = await createCollection(collectionData);

    if (!collectionResponse) {
      $this.data('processing', false);
      return alert("Failed to create collection.");
    }

    productItemData.collectionName = collectionData.name;
    productItemData.registrationId = uniqueId;
    const added = await addProductToCollection(productItemData);

    if (added[0]) {
      $(".wishlist_popup_main").removeClass("active");
      $(".create_collection_input").val("");
      $(`.wishlist_img_main[data-prod-id="${added[1]}"]`).addClass("active");
      jQuery(`.wishlist_img_main[data-prod-id="${added[1]}"]`)
        .closest(".ct_hart_icon_main")
        .find(".wish_added")
        .show();
      setTimeout(() => {
        jQuery(`.wishlist_img_main[data-prod-id="${added[1]}"]`)
          .closest(".ct_hart_icon_main")
          .find(".wish_added")
          .hide();
      }, 2000);

      var count = jQuery(".rb_wishlist_count").text();
      var total_count = parseInt(count) + 1;
      // jQuery(".rb_wishlist_count").text(total_count);
      jQuery(".rb_wishlist_count").addClass("rb_active_wish");
    } else {
      alert("Failed to add product to collection.");
    }
  } catch (error) {
    alert("An error occurred. Please try again.");
  } finally {
    // Re-enable the button after the operation completes
    $this.data('processing', false);
  }
});


 $(document).on("click", ".rdx_create_collection_btn", async function () {
  const $this = $(this);

  // Prevent multiple clicks by disabling the button temporarily
  if ($this.prop("disabled")) return;
  $this.prop("disabled", true);

  const uniqueId = getCookie("browserUniqueId") || generateUniqueId();
  setCookie("browserUniqueId", uniqueId, 365);
  var pd_type = $(".create_collection_input").val();
  collectionData.name = pd_type;
  collectionData.registrationId = uniqueId;

  try {
    const collectionResponse = await createCollection(collectionData);
    // Handle response if necessary (e.g., collectionResponse.status)

    productItemData.collectionName = collectionData.name;
    productItemData.registrationId = uniqueId;

    var collection_create={
      "folder_name":collectionData.name,
      "created_from":__st.p == "page"? "Wishlist Page":__st.p
     }


    const added = await addProductToCollection(productItemData);

    if (added) {
      jQuery(".current_input_row").removeClass("has-focus");
      jQuery(".ct_char span").text(0);

      $(".wishlist_popup_main").removeClass("active");
      $(".create_collection_input").val("");
      $(`.wishlist_img_main[data-prod-id="${added[1]}"]`).addClass("active");
      jQuery(`.wishlist_img_main[data-prod-id="${added[1]}"]`)
        .closest(".ct_hart_icon_main")
        .find(".wish_added")
        .show();
      setTimeout(() => {
        jQuery(`.wishlist_img_main[data-prod-id="${added[1]}"]`)
          .closest(".ct_hart_icon_main")
          .find(".wish_added")
          .hide();
      }, 2000);
      // Optionally update the wishlist count or UI here
    } else {
      alert("Failed to add product to collection.");
    }
  } catch (error) {
    alert("An error occurred. Please try again.");
  } finally {
    // Re-enable the button after the operation completes
    $this.prop("disabled", false);
  }
});


  $(document).on("input", ".create_collection_input", function () {
    toggleButtonState(".create_collection_input", ".rdx_create_collection_btn");
    jQuery(this).parent().find(".ct_char span").text($(this).val().length);
  });
  $(document).on("input", ".rb_wishlist_collection_name", function () {
    toggleButtonState(".rb_wishlist_collection_name", ".rb_wishlist_rename_save_btn");

    jQuery(this).parent().find(".ct_char span").text($(this).val().length);
  })

  // $("#current").keyup(function () {
  //   $(".ct_char span").text($(this).val().length);
  // });

  jQuery("input, select, textarea,email,password,tel").each(function (index) {
    var input = jQuery(this);
    input.on("focus", function () {
      jQuery(this).parent().addClass("has-focus");
    });

    input.on("focusout", function () {
      if (jQuery(this).val() == "") {
        jQuery(this).parent().removeClass("has-focus");
      }
    });
  });

  jQuery('input[type="text"],input[type="email"],input[type="password"],input[type="tel"],input[type="search"], select, textarea').each(function (index) {
    var input = jQuery(this);
    if (input.val() == "") {
      jQuery(input).parent().removeClass("has-focus");
    } else {
      jQuery(input).parent().addClass("has-focus");
    }
  });

  var url = window.location.href;
  var count_url = url.split("/").length;
  if (count_url == 6) {

    share_wishlist_data();
  }
  else {

    getCollectionData(true)
  }

  async function share_wishlist_data() {
    var url = window.location.href;
    var lastPart = url.split('/').pop(); // Extract the last part

    var token_list = lastPart.split('&')

    $.ajax({
      url: `${apiUrl}wishlist/collection-by-token/${token_list}`,
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }).done(async function (response) {
   
      if (response.length > 0) {
        jQuery.each(response, function (index, element) {
         
          $(".rb_wishlist_main").show();
          wishlist_collection_list(response, true);
        })
        jQuery('body').removeClass("rb_wishlist_empty");

      }
      else {
        wishlist_product_list()
        //        $(".rb_empty_wishlist").show();
        jQuery('body').addClass("rb_wishlist_empty");

        $(".wishlist_recent_pro").show();
        $(".rb_wishlist_main").hide();
      }
      ;
    });
  }

  async function getCollectionData(flag) {
    $.ajax({
      url: `${apiUrl}wishlist/collection?registrationId=${uniqueId}&customerId=${customerId}&collectionItems=${flag}`,
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }).done(async function (response) {
 
      if (response.length > 0) {
        jQuery.each(response, function (index, element) {
         
          $(".rb_wishlist_main").show();
          wishlist_collection_list(response);
          jQuery(".rb_collection_share_header").show();
        })
        jQuery('body').removeClass("rb_wishlist_empty");

      }
      else {
        wishlist_product_list()
        //$(".rb_empty_wishlist").show();
        jQuery('body').addClass("rb_wishlist_empty")
        $(".wishlist_recent_pro").show();
        $(".rb_wishlist_main").hide();
      }
      ;
    });

  }


  function wishlist_collection_list(response, w_flag = false) {
    var hidden_class
    if (w_flag) {

      jQuery(".rb_wishlist_title").text("Shared Wishlist");
      hidden_class = "rb_wishlist_hidden";
      jQuery(".rb_collection_share_header").addClass("rb_wishlist_hidden");
      jQuery(".rb_wish_product_tab").addClass("rb_wishlist_hidden");
    }

    var collection_count = response.length;
    $(".wishlist_collection_tab_count").text(`(${collection_count})`);
    const collections = response.map((element) => {
      const items = element.items.slice(0, 4).map(
        (item) => `<img src="${item}" loading="lazy">`
      );
      return `
            ${element.totalItem > 0 ? `
              <div class="ct_collection_box">
              <input type="checkbox" name="collection_id" class="rb_share_checkbox"  data-collection-id="${element.id}" data-collection-name="${element.name}">
                  <div class="ct_collection_checkbox"></div>
                <div class="ct_collection_img rb_wishlist_collection_img" data-collection-id="${element.id}" data-collection-name="${element.name}">
                  <div class="ct_collection_img_box_wrap">${items.join("")}</div>
                  
                </div>
                <div class="ct_collection_bottom">
                  <div class="ct_collection_title">${element.name}</div>
                  <div class="ct_collection_subtitle">${element.totalItem} Products</div>
                  <div class="rb_wishlist_three_dot_btn ${hidden_class}" data-collection-id="${element.id}" data-collection-name="${element.name}" data-collection-token="${element.tokenKey}">
                  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g opacity="0.9">
                      <path d="M15 9.375C16.0355 9.375 16.875 8.53553 16.875 7.5C16.875 6.46447 16.0355 5.625 15 5.625C13.9645 5.625 13.125 6.46447 13.125 7.5C13.125 8.53553 13.9645 9.375 15 9.375Z" fill="#454545"/>
                      <path d="M15 16.875C16.0355 16.875 16.875 16.0355 16.875 15C16.875 13.9645 16.0355 13.125 15 13.125C13.9645 13.125 13.125 13.9645 13.125 15C13.125 16.0355 13.9645 16.875 15 16.875Z" fill="#454545"/>
                      <path d="M15 24.375C16.0355 24.375 16.875 23.5355 16.875 22.5C16.875 21.4645 16.0355 20.625 15 20.625C13.9645 20.625 13.125 21.4645 13.125 22.5C13.125 23.5355 13.9645 24.375 15 24.375Z" fill="#454545"/>
                    </g>
                  </svg>
                  </div>
                </div>
              </div>`: ""}`;
    });

    $(".rb_wishlist_collection_list").html(collections.join(""));
    $(".rdx_create_collection_btn").hide();
    $(".create_collection_btn_secend").show();
    $(".rb_wishlist_collection_list").show();
  }
  var collectionId, collectionName;
  jQuery(document).on("click", ".rb_wishlist_three_dot_btn", function () {
    collectionId = jQuery(this).attr("data-collection-id");
    collectionName = jQuery(this).attr("data-collection-name");
    collectionToken = jQuery(this).attr("data-collection-token");
    jQuery(".rb_share_wishlist_title").text(collectionName);
    $(".rb_wishlist_three_dot_popup").show();
    jQuery(".rb_wishlist_share_box_main").show();
    jQuery(".rb_wishlist_edit_popup").hide();
    jQuery(".rb_wishlist_delete_popup").hide();
  })
  jQuery(document).on("click", ".wishlist_share_popup_bg", function () {
    $(".rb_wishlist_three_dot_popup").hide();
  })
  jQuery(document).on("click", ".rb_rename_collection_btn", function () {
    jQuery(".rb_wishlist_collection_name").val(collectionName);
    jQuery(".rb_wishlist_edit_popup").attr("data-collectionName", collectionName);
    jQuery(".rb_wishlist_collection_name").parent().find(".ct_char span").text(collectionName.length);
    jQuery(".rb_wishlist_collection_name").focus();
    jQuery(".rb_wishlist_collection_name").parent().addClass("has-focus");
    jQuery(".rb_wishlist_share_box_main").hide();
    jQuery(".rb_wishlist_edit_popup").show();
  })
  jQuery(document).on("click", ".rb_wishlist_cancel_btn", function () {
    jQuery(".rb_wishlist_edit_popup").hide();
    jQuery(".rb_wishlist_share_box_main").show();
  })
  jQuery(document).on("click", ".rb_wishlist_rename_save_btn", async function () {
    var collectionName = jQuery(".rb_wishlist_collection_name").val();
    var data = {
      "id": collectionId,
      "name": collectionName,
      "customerId": "",
      "registrationId": uniqueId
    }

    const collectionResponse = await updateCollection(data);
    var old_coll_name=jQuery(".rb_wishlist_edit_popup").attr("data-collectionname");

    if (!collectionResponse) {
      alert("Failed to update collection.");
    }
    else {
      getCollectionData(false);
      jQuery(".rb_wishlist_share_box_main").show();
      jQuery(".rb_wishlist_edit_popup").hide();
      $(".rb_wishlist_three_dot_popup").hide();
    }

  })
  async function updateCollection(data) {
    try {
      const response = await $.ajax({
        url: `${apiUrl}wishlist/collection`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify(data),
      });
      return response.success ? response : null;
    } catch {
      return null;
    }
  }

  jQuery(document).on("click", ".rb_delete_collection_btn", async function () {

    jQuery(".rb_wishlist_delete_popup").show();
    jQuery(".rb_wishlist_share_box_main").hide();

  });
  jQuery(document).on("click", ".rb_wishlist_delete_cancel_btn", function () {
    jQuery(".rb_wishlist_delete_popup").hide();
    jQuery(".rb_wishlist_share_box_main").show();
  });

  jQuery(document).on("click", ".rb_wishlist_delete_save_btn", async function () {
    
    var collection_delete={
      "folder_name":collectionName
     }
    // clevertap.event.push("wishlist folder deleted", collection_delete);
    const collectionResponse = await deleteCollection(collectionId);
    if (!collectionResponse) {
      alert("Failed to delete collection.");
    }
    else {
      getCollectionData(true);
      jQuery(".rb_wishlist_three_dot_popup").hide();
      wishlist_product_list();
    }
  });

  async function deleteCollection(collectionId) {
    try {
      const response = await $.ajax({
        url: `${apiUrl}wishlist/collection/${collectionId}`,
        method: "DELETE",
        headers: { "Content-Type": "application/json" }

      });
      return response.success ? response : null;
    } catch {
      return null;
    }
  }

  jQuery(document).on("click", ".wishlist_tab_list li a", function () {
    var url = window.location.href;
    var count_url = url.split("/").length;
    var hidden_class = "";
    if (count_url == 6) {
      // checking the sharewishlist page condition
    }else
    {
      jQuery(".wishlist_tab_list li a").removeClass("active");
      jQuery(this).addClass("active");
      var href_class = jQuery(this).attr("data-tab");
      var data_id = jQuery(this).attr("data-id");
      $(href_class).show();
      if (data_id == 2) {
        jQuery(".rb_collection_share_header").hide();
        jQuery(".wishlist_tab_content").removeClass("wishlist_share_active");
        $.ajax({
          url: `${apiUrl}customer/wishlist?registrationId=${uniqueId}&customerId=${customerId}`,
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }).done(async function (response) {
  
          var data = await getProductData(response);
          jQuery(".rb_wishlist_all_product_list").html(data);
          $(".rb_wishlist_collection_list").hide();
          $(".rb_wishlist_all_product_list").show();
          $(".rb_wishlist_collection_product_list").hide();
        });
  
      }
      else if (data_id == 1) {
  
        getCollectionData(true);
        $(".rb_wishlist_collection_list").show();
        $(".rb_wishlist_all_product_list").hide();
      }
    }

  })

  async function getProductData(productData) {
    var data = "";
    var url = window.location.href;
    var count_url = url.split("/").length;
    var hidden_class = "";
    if (count_url == 6) {
      hidden_class = "rb_wishlist_hidden";


    }
    jQuery.each(productData, function (index, element) {
      data += `<div class="ct_collection_product_box_item">
          <div class="ct_collection_product_box_item_img rb_wishlist_product_details" data-name="${element.name}">
              <img class="rb_wishlist_product_details_img" width="500" height="500" src="${element.image}" alt="${element.name}">
              <div class="rb_collection_wishlist_icon_main ${hidden_class}">
                <div class="ct_hart_icon ct_hart_icon-media">
                  <div class="wishlist_img_main active" data-prod-id="${element.groupId}" data-prod-title="${element.name}" data-prod-featured-image="${element.image}" data-prod-variant-id="${element.id}" 
                  data-prod-price="${element.price}"
                  data-prod-selling-price="${element.sellingPrice}"
                  >
                    <img class="wish_uncheck wishlist_blank_icon" width="30" height="30" src="https://cdn.shopify.com/s/files/1/0796/1959/files/wish_uncheck.webp?v=1734585398">
                    <img class="wish_fill wishlist_fill_icon" width="30" height="30" src="https://cdn.shopify.com/s/files/1/0796/1959/files/wish_fill.png">
                    
                  </div>
                </div>
                <div class="wish_added" style="display: none;">
                  <h2>Added To Wishlist</h2>
                </div>
              </div>
          </div>
          <div class="ct_collection_product_box_item_title">
              <span>${element.name}</span>
          </div>
          <div class="ct_collection_product_box_item_price">`;
      var discountPercentage = 0;
      var compare_price = 0;
      

      if (element.sellingPrice > element.price) {
        compare_price = element.sellingPrice;
        discountPercentage = (element.sellingPrice - element.price) / element.sellingPrice * 100;
      }
      data += `<span class="discount_price">${rupees}${element.price}</span>
              ${compare_price > 0 ? `<span class="original_price">${rupees}${compare_price}</span>` : ""}
              ${discountPercentage > 0 ? `<span class="discount_percentage">${discountPercentage}% OFF</span>` : ""}
          </div>
          <div class="ct_collection_product_box_addcart">
            <button class="ct_wishlist_addcart_btn" data-prod-variant-id="${element.id}">Add to Cart</button>
          </div>
        </div>`;
    })
    return data;
  }
  jQuery(document).on("click", ".rb_wishlist_collection_img", async function () {
    var collectionId = jQuery(this).attr("data-collection-id");
    var collectionName = jQuery(this).attr("data-collection-name");

    $.ajax({
      url: `${apiUrl}wishlist/collection/${collectionId}`,
      method: "GET",
      headers: { "Content-Type": "application/json" },
    }).done(async function (response) {
      jQuery(".rb_collection_share_header").hide();
   
      var data = `<div class="ct_product_bc_btn rb_collection_back_btn">
                  <div class="ct_product_bc_btn_inner ">
                      <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M0.376546 8.62345C-0.125528 8.12138 -0.125528 7.30726 0.376546 6.80519L6.80513 0.376574C7.30725 -0.125525 8.12131 -0.125525 8.62343 0.376574C9.12552 0.878687 9.12552 1.69275 8.62343 2.19486L3.10394 7.71432L8.62342 13.2338C9.12552 13.7359 9.12552 14.55 8.62342 15.0521C8.12131 15.5541 7.30724 15.5541 6.80513 15.0521L0.376546 8.62345Z" fill="#454545"/>
                      </svg>
                      <span>${response.name}</span>
                  </div>
              
              </div>`;
      data += `<div class="rb_wishlist_collection_product_list_inner rb_wishlist_all_product_list rb_collection_wishlist_icon_main">`;
      data += await getProductData(response.items);

      $(".rb_wishlist_collection_product_list").html(`${data}</div>`);
      $(".rb_wishlist_collection_list").hide();
      $(".rb_wishlist_collection_product_list").show();

    });
  })

  jQuery(document).on("click", ".rb_collection_back_btn", function () {
    var url = window.location.href;
    var count_url = url.split("/").length;
    if (count_url == 6) {
      share_wishlist_data()
    }
    else {
      getCollectionData(true);
    }
    $(".rb_wishlist_collection_product_list").hide();
    $(".rb_wishlist_collection_list").show();
  })
  jQuery(document).on("click", ".rb_add_to_cart, .ct_wishlist_addcart_btn", async function () {

    var variantId = jQuery(this).attr("data-prod-variant-id");

    var data = await addProductToCart(variantId);
    jQuery(".fetch_pro_pop_main").removeClass("active");
  })
  async function addProductToCart(variantId) {

    let formData = {
      'items': [{
        'id': variantId,
        'quantity': 1
      }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
        else
          {
                jQuery(".cart-link .cart-link__icon").trigger("click");
          }
          document.dispatchEvent(
            new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
          );
        })
      .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(error.message);
          this.dispatchEvent(new CustomEvent('on:cart:error', {
            bubbles: true,
            detail: {
              error: error.message
            }
          }));
          // Uncertainty... Reload page.
          window.location.reload();
        });
  }


  $(document).on('click', '.rb_wishlist_product_details .rb_wishlist_product_details_img ', function () {
    let s = $(this).attr('alt');
    if ($(".fet_preview").hasClass("slick-initialized")) {
      jQuery(".fet_preview").slick("unslick");
    }
    var data_handle = s.toLowerCase().replace(/[ .]/g, "-");

    let ajax_url = `${window.location.origin}/products/${data_handle}.js`;
    $.get(ajax_url, function (data) {
      var d = jQuery.parseJSON(data);
      var product_open={
        "product_id":d.name,
        "product_name":d.title
       }
      // clevertap.event.push("wishlist item clicked", product_open);
      var variantId = d.variants[0].id;
      var title = document.querySelector('.fet_title')
      title.innerText = d.title;

      var price = document.querySelector('.fet_price')
      price.innerText = `${rupees}` + ` ` + parseInt(d.price / 100);

      var link = document.querySelector('.fet_link')
      var link_1 = window.location.origin
      link.href = link_1 + d.url;

      var imgTag = "";
      d.images.forEach(function (image) {
        imgTag += `<div class="slide_img"><img src="${image}" alt="Preview Image"  /></div>`;
      });
      jQuery(".rb_add_to_cart").attr("data-prod-variant-id", variantId);
      $('.fet_preview').html(imgTag);

      $('.fet_preview').slick({
        slidesToShow: 1,
        variableWidth: true,
        dots: true
      });
      $(".fetch_pro_pop_main").addClass("active");
    });
  });
  $(document).on('click', '.fetch_pro_pop_close', function () {
    $(this).closest('.fetch_pro_pop_main').removeClass('active');
  });
  jQuery(document).on("click", ".rb_share_collection_btn", function () {

    navigator.share({
      title: collectionName,
      url: `${window.location.origin}/pages/wishlist/${collectionToken}`
    })
    jQuery(".rb_wishlist_three_dot_popup").hide();
  })

  jQuery(document).on("click", ".rb_share_btn", function () {
    jQuery("input[name='collection_id']").prop("checked", false);
    jQuery(".rb_share_all_collection_btn").prop("disabled", true);
    jQuery(".wishlist_tab_content").addClass("wishlist_share_active")
  })
  jQuery(document).on("click", ".ct_shere_bc_btn_inner", function () {
    jQuery("input[name='collection_id']").prop("checked", false);
    jQuery(".share_coll_btn").prop("disabled", true);
    jQuery(".wishlist_tab_content").removeClass("wishlist_share_active")
  })
  jQuery(document).on("change", ".rb_share_checkbox", function () {
    var checked_count = jQuery("input[name='collection_id']:checked").length;
    if (checked_count > 0) {
      jQuery(".share_coll_btn").removeAttr("disabled");
    }
    else {
      jQuery(".share_coll_btn").attr("disabled", "disabled");

    }
  })
  jQuery(document).on("click", ".rb_share_all_collection_btn", function () {
    if (!navigator.share) {
      alert("Sharing is not supported in this browser.");
      return;
    }

    const tokens = [];


    // Collect all tokens from selected checkboxes
    jQuery(".rb_wishlist_collection_list .ct_collection_box .rb_share_checkbox:checked").each(function () {
      const token = jQuery(this)
        .closest(".ct_collection_box")
        .find(".rb_wishlist_three_dot_btn")
        .attr("data-collection-token");

      if (token) {
        tokens.push(token);
      }
    });

    if (tokens.length > 0) {
      const tokenString = tokens.join("&"); // Join tokens with '&'

      navigator.share({
        title: "wishlist Share",
        url: `${window.location.origin}/pages/wishlist/${tokenString}`
      }).catch((error) => {
        console.error("Error sharing:", error);
      });
    } else {
      alert("No collections selected to share.");
    }
  });

});
